import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { compare } from "../../composants/utils/utils";
import { faDashboard } from "@fortawesome/free-solid-svg-icons";

export default function BreadCom({name, icon=faDashboard, data=[]}){
    return(
        <div className="bg-white p-4 mb-6 rounded-lg shadow-sm">
            <div className="container mx-auto">
                <div className="flex justify-between items-center">
                    <div className="p-4 sm:p-6 flex items-center">
                        <div className="bg-blue-100 p-2 rounded-lg mr-4">
                            <FontAwesomeIcon icon={icon} className="text-blue-600 text-xl" />
                        </div>
                        <h3 className="text-2xl font-semibold text-gray-800">
                        {name.toUpperCase()}
                        </h3>
                    </div>
                    {
                        (data.length != 0) && (
                            <div>
                                <nav className="flex" aria-label="Breadcrumb">
                                    <ol className="inline-flex items-center space-x-1 md:space-x-3">
                                        {
                                            data.sort(compare).map((value, index) => {
                                                if(value.last){
                                                    return (
                                                        <li key={index}>
                                                            <div className="flex items-center">
                                                                <span className="mx-2.5 text-gray-400">/</span>
                                                                <span className="text-gray-500">{value.name.toString().toUpperCase()}</span>
                                                            </div>
                                                        </li>
                                                    );
                                                } else {
                                                    return (
                                                        <li key={index}>
                                                            <div className="flex items-center">
                                                                {index !== 0 && <span className="mx-2.5 text-gray-400">/</span>}
                                                                <a href={value.path} className="text-blue-600 hover:text-blue-800">{value.name}</a>
                                                            </div>
                                                        </li>
                                                    );
                                                }
                                            })
                                        }
                                    </ol>
                                </nav>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
}